import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";
import imageEmpty from '../../../assets/ImageEmpty.svg';
import { ReactComponent as SearchGray } from '../../../assets/searchGray.svg';
import { ReactComponent as WhiteXCloseIcon } from "../../../assets/WhiteXCloseIcon.svg";
import ContactsPopup from "../../ContactsPopup/ContactsPopup";
import DeleteButton from "../../DeleteButton/DeleteButton";
import styles from "../CreateParameterPopup.module.css";
import LabelParameters from "../LabelParameters";


const Contact = ({
  parameterData,
  setParameterData,
  handleChange,
  editingInput,
  setEditingInput,
}) => {
  const [t] = useTranslation("Contacts");

  const [newAsset, setNewAsset] = useState(false);
  const [newContact, setNewContact] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const contactsRef = useRef(null);

  const handleContactClick = (contact) => {
    setInputValue('')
    setParameterData((prev) => ({
      ...prev,
      contact: [...(prev.contact || []), contact],
    }));
  };

  // Manejar clics fuera del contenedor de contactos
  const handleBlur = (event) => {
    setTimeout(() => {
      if (
        contactsRef.current &&
        !contactsRef.current.contains(event.relatedTarget)
      ) {
        setIsFocused(false);
      }
    }, 100);
  };
  const handleDeleteContact = (idToRemove) => {
    setParameterData((prev) => ({
      ...prev,
      contact: (prev.contact || []).filter((c) => c._id !== idToRemove),
    }));
  };
  
  return (
    <div>
      <LabelParameters
        value={parameterData.Contact}
        text={"contact"}
        editingInput={editingInput}
        setEditingInput={setEditingInput}
      >
        <div className={styles.inputContainer}>
            <SearchGray/>
          <input
            type="text"
            placeholder={t("searchContact")}
            onFocus={() => setIsFocused(true)}
            onBlur={handleBlur}
            onChange={(e) => setInputValue(e.target.value)}
            value={inputValue}
            className={styles.searchContactInput}
          /> 
          <FaChevronDown
             size={16}
             width={16}
             className={styles.chevronIcon}
             height={16}
             color={"#71717A"}
             />
          {isFocused && inputValue.length > 0 && (
            <ContactsPopup
              ref={contactsRef}
              handleContactClick={handleContactClick}
              setShowNewContact={() => {}}
              type={"contact"}
              inputValue={inputValue}
              setNewContact={setNewContact}
              setNewAsset={setNewAsset}
            />
          )}
        </div>
      </LabelParameters>

      {parameterData?.contact?.map((contact) => (
        <div className={styles.contactContent}>
         <div>
         <img src={contact.image || imageEmpty} alt="" />
          <div className={styles.contactInfo}>
            <p>{contact?.contactName}</p>
            {(() => {
              const bills = contact?.infoBill || [];
              const selectedBill = bills.find((b) => b.default) || bills[0];

              if (!selectedBill) return null; // No hay infoBill

              return (
                <div>
                  <span>{selectedBill.address || t('address')}</span>
                  <span>{selectedBill.population || t('population')}</span>
                  <span>{selectedBill.province || t('province')}</span>
                  <span>{selectedBill.zipCode || t('zipCode')}</span>
                  <span>{selectedBill.country || t('country')}</span>
                </div>
              );
            })()}
          </div>
         </div>
          <DeleteButton
        action={() => handleDeleteContact(contact._id)}
        type="black"
        CustonIcon={WhiteXCloseIcon}
        customIconStyles={{
            height: "20px",
            minWidth: "20px",
            maxWidth: "20px",
            background: "#6E6E80",
          }}
      />
        </div>
      ))}
    </div>
  );
};

export default Contact;
